import React, { Fragment, Suspense } from "react";
import { metaTag } from "../Library/commomLib";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
const SuccessComponent = React.lazy(() => import("../Components/RootComponents/SuccessComponent"));
const SuccessPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <SuccessComponent />
      </Suspense>
    </Fragment>
  );
};

export default SuccessPage;
